import { Mapper } from "../../../../../core/base";
import { GeoAddressWebEntity } from "./geo-address-web-entity";
import { GeoAddress } from "../../../../../core/domain";
import { AddressWebRepositoryMapper } from "./address-web-repository-mapper";

export class GeoAddressWebRepositoryMapper extends Mapper<GeoAddressWebEntity, GeoAddress> {
  mapFrom(param: GeoAddressWebEntity): GeoAddress {
    const addressMapper = new AddressWebRepositoryMapper();
    return {
      address: addressMapper.mapFrom(param.address),
      providedAddress: param.providedAddress,
      latitude: param.latitude,
      longitude: param.longitude,
      relevance: param.relevance
    };
  }

  mapTo(param: GeoAddress): GeoAddressWebEntity {
    const addressMapper = new AddressWebRepositoryMapper();
    return {
      address: addressMapper.mapTo(param.address),
      providedAddress: param.providedAddress,
      latitude: param.latitude,
      longitude: param.longitude,
      relevance: param.relevance
    };
  }

}
